import React from "react";

import {
  CONTEXT_LAYOUT_IDS,
  CONTEXT_LAYOUT_INFO,
} from "../explanation_pages/contextLayouts";

/**
 * LES FORMATS DE PAGE DE CONTEXTE, DESSINÉS.
 *
 * Même parti pris que `stepKinds.js`, pour la même raison : un auteur ne
 * choisit pas « only_media » dans une liste, il choisit une forme d'écran. Le
 * croquis dit en un coup d'œil ce que trois cases à cocher mettaient une phrase
 * à expliquer — et surtout ce qu'elles ne disaient pas du tout, à savoir à quoi
 * la page ressemble une fois projetée.
 *
 * Les croquis sont schématiques (aplats, aucun texte) : ils représentent une
 * MISE EN PAGE et doivent rester lisibles à 100 px de large dans l'inspecteur.
 *
 * Ce fichier ne connaît que l'apparence des formats. Ce qu'ils CONTIENNENT est
 * dans `contextLayouts.js`, du côté du jeu, parce que c'est le rendu qui en
 * décide et que le builder n'a pas à en tenir une seconde description.
 */

const INK = "#94a3b8";
const FILL = "#e2e8f0";
const ACCENT = "#54a8ba";

function Sketch({ children, title }) {
  return (
    <svg viewBox="0 0 64 40" className="step-sketch" role="img" aria-label={title}>
      <rect x="0.5" y="0.5" width="63" height="39" rx="4" fill="#0a1a24" stroke={INK} strokeOpacity="0.4" />
      {children}
    </svg>
  );
}

const SKETCHES = {
  slide: (
    <Sketch title="Diapo">
      <rect x="7" y="6" width="50" height="28" rx="2" fill={FILL} fillOpacity="0.9" />
      <path d="M13 29 L23 18 L30 24 L40 12 L51 29 Z" fill={ACCENT} fillOpacity="0.75" />
      <circle cx="46" cy="12" r="2.5" fill={ACCENT} />
    </Sketch>
  ),
  split: (
    <Sketch title="Média et panneau">
      <rect x="5" y="8" width="30" height="24" rx="2" fill={FILL} fillOpacity="0.9" />
      <path d="M9 28 L17 19 L23 24 L29 16 L33 28 Z" fill={ACCENT} fillOpacity="0.7" />
      <rect x="39" y="8" width="20" height="14" rx="2" fill={FILL} fillOpacity="0.5" />
      <rect x="42" y="12" width="14" height="1.8" rx="0.9" fill={INK} />
      <rect x="42" y="16" width="11" height="1.8" rx="0.9" fill={INK} />
      <rect x="39" y="25" width="20" height="7" rx="2" fill={ACCENT} fillOpacity="0.45" />
    </Sketch>
  ),
  text: (
    <Sketch title="Texte seul">
      <rect x="12" y="11" width="40" height="18" rx="2" fill={FILL} fillOpacity="0.85" />
      <rect x="17" y="16" width="30" height="2.2" rx="1.1" fill={INK} />
      <rect x="20" y="21" width="24" height="2.2" rx="1.1" fill={INK} />
    </Sketch>
  ),
  cover: (
    <Sketch title="Plein cadre">
      <rect x="2" y="2" width="60" height="36" rx="3" fill={ACCENT} fillOpacity="0.55" />
      <path d="M2 30 L18 16 L30 26 L44 12 L62 30 L62 38 L2 38 Z" fill={ACCENT} fillOpacity="0.85" />
      <rect x="2" y="24" width="60" height="14" rx="0" fill="#0a1a24" fillOpacity="0.55" />
      <rect x="7" y="28" width="28" height="2.4" rx="1.2" fill={FILL} />
      <rect x="7" y="33" width="20" height="2.4" rx="1.2" fill={FILL} fillOpacity="0.7" />
    </Sketch>
  ),
  compare: (
    <Sketch title="Comparaison">
      <rect x="5" y="7" width="25" height="19" rx="2" fill={FILL} fillOpacity="0.9" />
      <path d="M8 23 L15 15 L20 20 L26 23 Z" fill={ACCENT} fillOpacity="0.7" />
      <rect x="34" y="7" width="25" height="19" rx="2" fill={FILL} fillOpacity="0.9" />
      <path d="M37 23 L44 13 L50 19 L55 23 Z" fill={ACCENT} fillOpacity="0.45" />
      <rect x="9" y="30" width="17" height="2.2" rx="1.1" fill={INK} />
      <rect x="38" y="30" width="17" height="2.2" rx="1.1" fill={INK} />
    </Sketch>
  ),
};

export const CONTEXT_KINDS = CONTEXT_LAYOUT_IDS.map((id) => ({
  id,
  label: CONTEXT_LAYOUT_INFO[id].label,
  hint: CONTEXT_LAYOUT_INFO[id].hint,
  sketch: SKETCHES[id],
}));

export function contextSketch(layout) {
  return SKETCHES[layout] || SKETCHES.slide;
}
